import React, { Component } from 'react';
import {Card, CardTitle, Col} from "reactstrap";
import MaterialIcon from "material-icons-react";

class TicketCard extends Component {

    render() {
        const {ticketCol, ticketBody, centerItem, ticketName} = styles;
        const {ticket, backgroundColor, ticketBorder, iconColor, textColor} = this.props;

        return (
            <Col md={3} style={Object.assign({},ticketCol, {backgroundColor: backgroundColor})} onClick={() => this.props.selectTicket(ticket)}>
                <Card body style={Object.assign({border: ticketBorder},ticketBody)}>
                    <div style={Object.assign({},centerItem)}>
                        <MaterialIcon icon={ticket.icon} size={38} color={iconColor} />
                    </div>
                    <CardTitle style={Object.assign({},centerItem, ticketName, {color: textColor})}>
                        {ticket.name}
                    </CardTitle>
                </Card>
            </Col>
        );
    }
}

export default TicketCard;

let styles = {
    ticketCol: {
        margin: '15px 0px',
        padding: 23,
        cursor: 'pointer'
    },
    ticketBody: {
        height: 140,
        justifyContent: 'center'
    },
    centerItem: {
        display: 'flex',
        justifyContent: 'center'
    },
    ticketName: {
        fontSize: 16,
        paddingTop: 12,
        textAlign: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/support/TicketCard.js